<div class="container">
    <!-- Sección izquierda - Video -->
    <div class="left">
        <!-- Video con iframe -->
         <div *ngIf="!showWelcomeMessage && showVideo && videoUrl" class="video-container">
            <iframe [src]="videoUrl" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen class="custom-video">
            </iframe>
            <!-- Overlay general para opacidad y bloqueo de clics -->
            <div class="video-overlay video-overlay-blocker"></div>
            <!-- Overlay superior -->
            <div class="video-overlay video-overlay-top"></div>
            <!-- Overlay inferior -->
            <div class="video-overlay video-overlay-bottom"></div>
            <!-- Control de sonido -->
            <button class="sound-toggle-btn" (click)="toggleSound()" [title]="isMuted ? 'Activar sonido' : 'Silenciar'">

                <!-- Icono de silencio -->
                <svg *ngIf="isMuted" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M3,9v6h4l5,5V4L7,9H3z" fill="white" />
                    <path
                        d="M16.5,12c0-1.77-1.02-3.29-2.5-4.03v8.05C15.48,15.29,16.5,13.77,16.5,12z M14,3.23v2.06 c2.89,0.86,5,3.54,5,6.71s-2.11,5.85-5,6.71v2.06c4.01-0.91,7-4.49,7-8.77S18.01,4.14,14,3.23z"
                        fill="white" opacity="0.5" />
                    <line x1="23" y1="3" x2="3" y2="21" stroke="white" stroke-width="2" stroke-linecap="round" />
                </svg>

                <!-- Icono de sonido activo -->
                <svg *ngIf="!isMuted" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M3,9v6h4l5,5V4L7,9H3z" fill="white" />
                    <path
                        d="M16.5,12c0-1.77-1.02-3.29-2.5-4.03v8.05C15.48,15.29,16.5,13.77,16.5,12z M14,3.23v2.06 c2.89,0.86,5,3.54,5,6.71s-2.11,5.85-5,6.71v2.06c4.01-0.91,7-4.49,7-8.77S18.01,4.14,14,3.23z"
                        fill="white" />
                </svg>
            </button>
        </div>

        <!-- Placeholder mientras no hay video -->
        <div *ngIf="!showWelcomeMessage && !showVideo" class="video-placeholder">
            <div class="play-icon"></div>
        </div>
         
        <!-- Welcome banner -->
         <div *ngIf="showWelcomeMessage" class="banner-container">
            <h1 class="banner-title">!Te damos la bienvenida a tu Etapa Phoenix!</h1>
            <div class="banner-spacer"></div>
            <h3 class="banner-description">
                Estamos felices de acompañarte en esta nueva etapa de vida. Cuéntanos un poco más sobre ti para personalizar tu experiencia. Este proceso toma 
                <span class="banner-description-strong">menos de 2 minutos.</span>
            </h3>
         </div>
    </div>

    <!-- Sección derecha - Formulario de registro -->
    <div class="right">
        <router-outlet></router-outlet>
    </div>
</div>